import API from '../api'
import getUrl from './paths'

export const getDashboardData = (userId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getUserDashboard, {
			userId,
		})
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getCompanyData = (employeeId = null, accessType, numMonths = 6) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getCompanyDashboard, { employeeId, accessType, numMonths })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getCompanyDashboardDataV2 = (employeeId = null, type, fromMonth, toMonth, organisationId, userId, removeDefault = true, platform) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getCompanyDashboardDataV2, {
			userId,
			employeeId,
			type,
			fromMonth,
			toMonth,
			organisationId,
			removeDefault,
			platform,
		})
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getManagerDashboardData = (userId, employeeId = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getManagerDashboardData, { userId, employeeId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getUsersMonthlyTarget = () =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getUsersMonthlyTarget)
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getPendingOrderReports = () =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getPendingOrder)
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getOrganisationDashboardData = (organisationId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getOrganisationDashboardData, { organisationId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getLatestDashboardHtmlFileApi = (reportType) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getLatestDashBoardHtmlFile, { reportType })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})
